import * as z from "zod/v4";

export const updateMessagingGroup = {
  name: "updateMessagingGroup" as const,
  input: z.object({
    id: z.string(),
    name: z.string().min(1, "Name is required").optional(),
    channelIds: z
      .array(z.string())
      .min(1, "At least one channel is required")
      .optional(),
  }),
  output: z.object({
    _id: z.string(),
    name: z.string(),
    channelIds: z.array(z.string()),
    createdAt: z.date(),
    updatedAt: z.date(),
  }),
};
